import React from 'react';
import { Route, Switch, Router, Redirect } from 'react-router-dom';
import { Provider } from 'unstated';
import JamRecipes from './JamRecipes';
import SelectJamParentPage from './SelectJamParentPage';
import PromptPage from './PromptPage';
import DraftTitleAndBlurbPage from './DraftTitleAndBlurbPage';
import CrewDraftPage from './CrewDraftPage';
import StartSessionPage from './StartSessionPage';
import EndSessionPage from './EndSessionPage';
import WrapUpPage from './WrapUpPage';
import ListingPage from './ListingPage';
import LoginPage from './LoginPage';
import FullPageJamDetail from './FullPageJamDetail';

import history from '../libraries/History';
import session from '../models/Session';

function Page(Component) {
  return props => (
    <Provider>
      <Component {...props} />
    </Provider>
  );
}


const RouterSwitch = () => (
  <Router history={history}>
    <Switch>
      <Route exact path="/create" component={Page(JamRecipes)} />
      <Route exact path="/create/:slug/select" component={Page(SelectJamParentPage)} />
      <Route exact path="/create/:slug/select/addPrompt" component={Page(PromptPage)} />
      <Route exact path="/create/:slug/select/addPrompt/addTitle" component={Page(DraftTitleAndBlurbPage)} />
      <Route exact path="/crew/:id/wrapup" component={Page(WrapUpPage)} />
      <Route exact path="/crew/:id?/:number?" component={Page(CrewDraftPage)} />
      <Route exact path="/crew/:id/:number/start" component={Page(StartSessionPage)} />
      <Route exact path="/crew/:id/:number/end" component={Page(EndSessionPage)} />
      <Route exact path="/session/jam/start/:id?" component={Page(StartSessionPage)} />
      <Route exact path="/session/jam/end/:id?" component={Page(EndSessionPage)} />
      <Route exact path="/session/:id/wrapup" component={Page(WrapUpPage)} />
      <Route exact path="/card/detail/:type/:id?" component={Page(FullPageJamDetail)} />
      <Route exact path="/logout" render={() => {
        session.clear(); 
        return (
          <Redirect to="/login" />
        );
      }}/>

      <Route exact path="/login" component={Page(LoginPage)} />
      <Route exact path="/" component={Page(ListingPage)} />
    </Switch>
  </Router>
);
export default RouterSwitch;



// WEBPACK FOOTER //
// ./src/pages/RouterSwitch.js